import Vue from 'vue'
import Vuex,{Store} from 'vuex'
import user from './modules/user'
import home from './modules/home'

Vue.use(Vuex)

// actions中的方法用于响应组件中的动作 —— 服务员
const actions = {
  jia({state,commit},value){
    if(state.a < 10){
      commit('JIA',value)
      // return ''
    }else{
      // alert('不能再加了，因为不能超过10')
      return Promise.reject('不能大于10')
    }
  }
}

// mutations中的方法用于修改状态 —— 厨师
const mutations = {
  JIA(state,value){
    state.a += value
  }
}

// state用于指定初始的数据 —— 原材料
const state = {
  a:1
}

export default new Store({
  actions,
  mutations,
  state,
  modules:{
    user,
    home
  }
})